import { DvToolbarAction } from '@devinco/ui/grid';
import 'ag-grid-enterprise';
import {
  Component,
  OnInit,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { GridOptionsService } from '@features/vt-grid/grid-options/grid-options.service';
import { Entity } from '@shared/constants/entity';
import { UserDto } from '@shared/interfaces/user.model';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import {
  GridOptions,
  GridReadyEvent,
  IRowNode,
  SelectionChangedEvent,
} from 'ag-grid-community';
import { take } from 'rxjs';
import { PoiGridService } from './poi-grid.service';
import { DvSplitterEventsService } from '@devinco/ui/dds/splitter';

@Component({
  selector: 'app-poi-grid',
  templateUrl: './poi-grid.component.html',
  styleUrls: ['./poi-grid.component.scss'],
  providers: [GridOptionsService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class POIGridComponent implements OnInit {
  readonly gridOptionsService = inject(GridOptionsService);
  private poiGridService = inject(PoiGridService);
  private splitterEvents = inject(DvSplitterEventsService);
  private permissionsService = inject(UserRolesAndPermissionsService);

  actions = signal<DvToolbarAction[]>([]);
  gridOptions: GridOptions;

  private selectedNode?: IRowNode<UserDto>;
  private canDelete: boolean;

  ngOnInit(): void {
    this.gridOptions = {
      ...this.gridOptionsService.serverSide(
        this.poiGridService.colDefs,
        Entity.POI
      ),
    };
    this.actions.set(this.poiGridService.getGridActions(this.onEditClick));

    this.permissionsService
      .hasPermissions([RolesAndPermissions.POIDelete])
      .pipe(take(1))
      .subscribe(hasPermissions => {
        this.canDelete = hasPermissions;
      });
  }

  onGridReady(event: GridReadyEvent): void {
    this.poiGridService.gridApi = event.api;
    this.poiGridService.gridContext = event.context;
  }

  onSelectionChanged({ api }: SelectionChangedEvent): void {
    this.selectedNode = api.getSelectedNodes()[0];

    this.actions.update(actions =>
      actions.map(action => {
        if (action.icon === 'edit') {
          return { ...action, disabled: !this.selectedNode };
        }
        if (action.icon === 'delete') {
          return {
            ...action,
            disabled: !this.canDelete || !this.selectedNode,
          };
        }
        return action;
      })
    );
  }

  private onEditClick = (): void =>
    this.splitterEvents.isSplitterOpened$.next(true);
}
